import React from "react";
import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import "../styles/Footer3.css";
import logo from "../assets/images/logo/blue-v-logo.png";
import {
  FaPhone,
  FaEnvelope,
  FaLocationDot,
  FaFacebookF,
  FaInstagram,
  FaLinkedinIn,
  FaYoutube,
} from "react-icons/fa6";

const socialLinks = [
  {
    label: "Facebook",
    href: "https://www.facebook.com/vessellagroup/",
    icon: <FaFacebookF />,
  },
  {
    label: "Instagram",
    href: "https://www.instagram.com/vessellagroup/",
    icon: <FaInstagram />,
  },
  {
    label: "LinkedIn",
    href: "https://in.linkedin.com/company/vessella-group",
    icon: <FaLinkedinIn />,
  },
  {
    label: "YouTube",
    href: "https://www.youtube.com/@vessellagrouphyd",
    icon: <FaYoutube />,
  },
];

const mainLinks = [
  { label: "Home", to: "/" },
  { label: "About Us", to: "/about-us" },
  { label: "Projects", to: "/projects" },
  { label: "Contact Us", to: "/contact" },
];

const projectLinks = [
  { label: "Serene", to: "/serene" },
  { label: "Palms", to: "/palms" },
  { label: "Meadows", to: "/meadows" },
  { label: "Woods", to: "/woods" },
  { label: "Villas", to: "/villas" },
  { label: "Cyber Meadows", to: "/cyber-meadows" },
  { label: "Mokhila", to: "/mokhila" },
  { label: "Karimnagar", to: "/karimnagar" },
  { label: "Narsingi", to: "/narsingi" },
  { label: "Kismathpur", to: "/kismathpur" },
];

export default function Footer() {
  const footerContainer = {
    hidden: {},
    show: {
      transition: {
        staggerChildren: 0.18,
      },
    },
  };

  const fadeUp = {
    hidden: {
      opacity: 0,
      y: 24,
    },
    show: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.8,
        ease: [0.22, 1, 0.36, 1],
      },
    },
  };

  const socialsContainer = {
    hidden: {},
    show: {
      transition: {
        staggerChildren: 0.1,
        delayChildren: 0.2,
      },
    },
  };

  const socialItem = {
    hidden: {
      y: 12,
    },
    show: {
      y: 0,
      transition: {
        duration: 0.5,
        ease: "easeOut",
      },
    },
  };

  return (
    <motion.footer
      className="footer text-white"
      variants={footerContainer}
      initial="hidden"
      whileInView="show"
      viewport={{ once: true, amount: 0.2 }}
    >
      <div className="footer-inner container-fluid px-lg-5 px-3 py-5">
        <motion.div className="footer-grid" variants={footerContainer}>
          <motion.div className="footer-brand" variants={fadeUp}>
            <motion.img
              src={logo}
              alt="Vessella Logo"
              className="footer-logo"
              variants={fadeUp}
            />

            <motion.div className="socials" variants={socialsContainer}>
              {socialLinks.map((item) => (
                <motion.a
                  key={item.label}
                  href={item.href}
                  target="_blank"
                  variants={socialItem}
                  rel="noopener noreferrer"
                  aria-label={item.label}
                >
                  {item.icon}
                </motion.a>
              ))}
            </motion.div>
          </motion.div>

          <motion.div className="footer-column" variants={fadeUp}>
            <h3 className="footer-heading">Main Links</h3>
            <motion.ul
              className="footer-links list-unstyled mb-0"
              variants={socialsContainer}
            >
              {mainLinks.map((item) => (
                <motion.li key={item.label} variants={socialItem}>
                  <Link to={item.to}>{item.label}</Link>
                </motion.li>
              ))}
            </motion.ul>
          </motion.div>

          <motion.div className="footer-column" variants={fadeUp}>
            <h3 className="footer-heading">Projects</h3>
            <motion.ul
              className="footer-links footer-project-links list-unstyled mb-0"
              variants={socialsContainer}
            >
              {projectLinks.map((item) => (
                <motion.li key={item.label} variants={socialItem}>
                  <Link to={item.to}>{item.label}</Link>
                </motion.li>
              ))}
            </motion.ul>
          </motion.div>

          <motion.div className="footer-column footer-connect" variants={fadeUp}>
            <h3 className="footer-heading">Connect With Us</h3>
            <div className="footer-contact-list">
              <a href="tel:04023014498" className="footer-contact-row">
                <span className="footer-contact-icon">
                  <FaPhone />
                </span>
                <span>
                  <small>Head Office</small>
                  040 23014498 / 99
                </span>
              </a>

              <a href="tel:+919121244421" className="footer-contact-row">
                <span className="footer-contact-icon">
                  <FaPhone />
                </span>
                <span>
                  <small>Marketing</small>
                  9121244421 / 03
                </span>
              </a>

              <a href="mailto:info@vessella.in" className="footer-contact-row">
                <span className="footer-contact-icon">
                  <FaEnvelope />
                </span>
                <span>
                  <small>Email</small>
                  info@vessella.in
                </span>
              </a>

              <a
                href="https://maps.google.com/?q=1st+Floor,+East+Block,+Cyber+Meadows,+Kondapur,+Hyderabad+-+500084.+T.S.+India"
                target="_blank"
                rel="noopener noreferrer"
                className="footer-contact-row"
              >
                <span className="footer-contact-icon">
                  <FaLocationDot />
                </span>
                <span>
                  <small>Office</small>
                  1st Floor, East Block, Cyber Meadows, Kondapur, Hyderabad.
                </span>
              </a>
            </div>
          </motion.div>
        </motion.div>

        <motion.div
          className="footer-bottoms geist-font mt-5 pt-4"
          variants={fadeUp}
        >
          <span>
            &copy; VESSELLA ALL RIGHTS RESERVED. Designed and Developed by{" "}
            <a href="https://www.dezainally.com" target="_blank" rel="noopener noreferrer">
              Dezainally
            </a>
          </span>
          <span>
            <Link className="footer-bottom-link" to="/privacy-policy">
              Cookies & Privacy Policy
            </Link>
          </span>
        </motion.div>
      </div>
    </motion.footer>
  );
}
